import { Images } from 'utils';
import { formModelEnums } from 'pages/forms/constants';
import { noteEnums } from '../../../schedule/core/modals/apptDetail/constants';

export const docTabEnums = {
    ABC_DATA: 'ABC_DATA',
    SESSION_NOTE: 'SESSION_NOTE',
};

export const docTabs = [
    { id: docTabEnums.ABC_DATA, label: 'ABC Data', icon: Images.addAbc, noteType: noteEnums.ABC_DATA },
    { id: docTabEnums.SESSION_NOTE, label: 'Session Note', icon: Images.noteTab, noteType: noteEnums.CLINICAL_NOTES },
];

/** Form-builder model whose published templates feed each tab's creation flow. */
export const docTabFormModel = {
    [docTabEnums.ABC_DATA]: formModelEnums.ABC_DATA,
    [docTabEnums.SESSION_NOTE]: formModelEnums.CLINICALNOTES,
};

export const docEntryNoun = {
    [docTabEnums.ABC_DATA]: 'ABC Entry',
    [docTabEnums.SESSION_NOTE]: 'Session Note',
};

/** Shown instead of a form when a tab has no entries yet and the clinician hasn't started one. */
export const docEmptyState = {
    [docTabEnums.ABC_DATA]: {
        title: 'No ABC data yet',
        subTitle: "Use 'Add new entry' to record the first ABC entry for this session.",
        image: Images.addAbc,
    },
    [docTabEnums.SESSION_NOTE]: {
        title: 'No session notes yet',
        subTitle: "Use 'Add new entry' to write the first session note for this session.",
        image: Images.noteTab,
    },
};

const PREVIEW_MAX_LENGTH = 60;

/** Strip tags/entities from a rich-text value and collapse whitespace. */
const toPlainText = (value) => {
    if (typeof value !== 'string' || !value) return '';
    const withoutTags = value.replace(/<[^>]*>/g, ' ');
    const decoded = withoutTags
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
    return decoded.replace(/\s+/g, ' ').trim();
};

/**
 * First piece of text the author actually wrote, used as the history card's subtitle.
 * Walks sections → attributes → children, since nested attributes are common in templates.
 */
export const entryPreview = (entry) => {
    const walk = (attributes) => {
        for (const attribute of attributes || []) {
            const text = toPlainText(attribute?.value);
            if (text) return text;
            const fromChildren = walk(attribute?.children);
            if (fromChildren) return fromChildren;
        }
        return '';
    };

    let preview = '';
    for (const section of entry?.template?.sections || []) {
        preview = walk(section?.attributes);
        if (preview) break;
    }
    if (!preview) return '';
    return preview.length > PREVIEW_MAX_LENGTH ? `${preview.slice(0, PREVIEW_MAX_LENGTH).trimEnd()}...` : preview;
};

/**
 * Entries are numbered in creation order (#1 is the oldest) but listed newest-first, so the
 * label is derived from position in an ascending copy rather than from the rendered index.
 */
export const buildEntryNumbers = (entries) => {
    const ascending = [...(entries || [])].sort((a, b) => new Date(a?.created) - new Date(b?.created));
    return ascending.reduce((acc, entry, index) => {
        if (entry?.id) acc[entry.id] = index + 1;
        return acc;
    }, {});
};

export const entryLabel = (tab, number) => `${docEntryNoun[tab]} #${number ?? ''}`.trim();
